// extracted by mini-css-extract-plugin
module.exports = {"row":"_2YkLDqBGZke_T_Mu0QXaej"};